import React from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import { CreditCard, Lock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * Para usuários com plano free: libera apenas Dashboard e a página de assinatura (/assinar).
 * "Ver Planos" leva para /assinar, onde o usuário escolhe Starter, Pro ou Lifetime e paga via PIX.
 */
export const FreePlanBlocker: React.FC = () => {
  const { pathname } = useLocation();
  const { isFreePlan, loading } = useAuth();

  const isDashboard = pathname === '/' || pathname === '';
  const isAssinar = pathname === '/assinar';
  const allowedForFree = isDashboard || isAssinar;

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[40vh]">
        <div className="text-gray-500 text-sm">Carregando...</div>
      </div>
    );
  }

  // Bloqueia todas as páginas exceto Dashboard para free (mesma tela de bloqueio que HotCloner, Repasse, etc.)
  if (isFreePlan && !allowedForFree) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[50vh] px-6 text-center">
        <div className="w-16 h-16 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center mb-6">
          <Lock className="text-orange-500" size={32} />
        </div>
        <h2 className="text-xl font-bold text-white mb-2">Conteúdo exclusivo para assinantes</h2>
        <p className="text-gray-400 text-sm max-w-sm mb-8">
          Esta página está disponível apenas para usuários com plano ativo. Assine um plano para acessar todas as funcionalidades.
        </p>
        <div className="glass-button-wrap">
          <Link to="/assinar" className="glass-button" style={{ textDecoration: 'none' }}>
            <span className="glass-button-text size-default">
              <CreditCard size={20} />
              Ver Planos
            </span>
          </Link>
          <div className="glass-button-shadow" />
        </div>
      </div>
    );
  }

  return <Outlet />;
};
